import { render, staticRenderFns } from "./MarketingPlanModal.vue?vue&type=template&id=08f7ad5c&scoped=true&"
import script from "./MarketingPlanModal.vue?vue&type=script&lang=js&"
export * from "./MarketingPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPlanModal.vue?vue&type=style&index=0&id=08f7ad5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7ad5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VImg,VRow})
